module.exports = __webpack_public_path__ + "assets/img/0b4e-lv.svg";